import { Stack } from '@workramp/ui';
import styled from 'styled-components';

export const FullWidthStack = styled(Stack)`
  padding: ${({ theme }) => theme.spacing(6)}px;
  padding-left: 0px;
`;

export const SkeletonWrapper = styled.div<{ widthPercent?: number }>`
  width: ${({ widthPercent }) => (widthPercent ? `${widthPercent}%` : '100%')};
`;
